var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fake-material-input"},[_c('div',{staticClass:"card-element",attrs:{"id":_vm.cardElementId}}),_c('div',{staticClass:"input-effect",class:{ 'input-effect-focus': _vm.focus }})])
}
var staticRenderFns = []

export { render, staticRenderFns }